import React from "react";

const LoadButton = () => {
  return (
    <button className="btn btn-primary" type="button" disabled>
      <span
        className="spinner-border spinner-border-sm"
        role="status"
        aria-hidden="true"
      ></span>
      <div>
        הקובץ בבדיקה
        <br />
        הנתונים מתעדכנים למערכת
      </div>
    </button>
  );
};

export default LoadButton;
